module.exports = "/images/da0db66ced59541e2c51eec641bba370.png";